import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

/**
 * El gridEdition tiene una estructura muy particular:
 *
 * Overlay > Modal > !!! iframe !!!
 *
 * iframe > ...
 *
 * Por este motivo no se pueden aplicar ni todos los estilos desde fuera
 * (overlay), ni todos los estilos desde dentro (document)
 *
 * @see
 *
 * iframeModal
 * layout.common.modals.iframeOverlay
 * layout.common.modals.gridEdition
 * layout.common.modals.overlayClassnames.gridEdition
 * layout.execution.form.editGrid
 */
const editGrid: ThemeUICSSObject = {
  height: '100%',
  padding: 0,

  '.confirm': {
    maxHeight: '100vh',
    overflow: 'hidden',

    '.confirm__content': {
      overflow: 'auto',
    },
  },

  '.fieldWrapper': {
    flexDirection: 'column',
    '& label': { width: '100%' },
  },

  '.fieldLabelWrapper': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    '.fieldLabelWrapper__buttons': {
      display: 'flex',
      gap: spacing(2),
    },
  },
};

export default editGrid;
